var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"blur-2 semi-transparent"},[_c('img',{attrs:{"src":`/images/preview/${_vm.$store.state.theme}/focus.jpg`}})])
}
var staticRenderFns = []

export { render, staticRenderFns }